import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import { TimeValueToggle as TimeValueToggleComponent } from '@components/TimeValueToggle'
import { TimeValue } from '@hooks/useTimeValue'

const context = createContext()

const useScenarioHeaderContext = () => {
  const contextValue = useContext(context)
  if (!contextValue) {
    throw new Error('DashboardHeader must be used within a DashboardHeaderProvider')
  }
  return contextValue
}

const Root = ({
  label,
  scenarioName,
  timeValue,
  setTimeValue,
  children
}) => {
  return (
    <context.Provider value={{ timeValue, setTimeValue, label, scenarioName }}>
      <section className='scenario-header header flex px-4 pt-4'>
        {children}
      </section>
    </context.Provider>
  )
}

const PlanName = () => {
  const { label, scenarioName } = useScenarioHeaderContext()

  if (!scenarioName || !label) {
    throw new Error('scenarioName and label must be defined to use PlanName')
  }

  return (
    <div className='scenario-header__details flex-row items-center'>
      <div className='scenario-details__plan-name'>
        <h1>
          { label ? <label>{label}</label> : null }
          {scenarioName}
        </h1>
      </div>
    </div>
  )
}

const TimeValueToggle = () => {
  const { timeValue, setTimeValue } = useScenarioHeaderContext()

  if (!timeValue || !setTimeValue) {
    throw new Error('timeValue and setTimeValue must be defined to use TimeValueToggle')
  }

  return (
    <div className='hidden sm:block'>
      <TimeValueToggleComponent timeValue={timeValue} setTimeValue={setTimeValue}/>
    </div>
  )
}

export const ScenarioHeader = Object.assign(Root, {
  PlanName,
  TimeValueToggle
})

ScenarioHeader.propTypes = {
  label: PropTypes.string,
  scenarioName: PropTypes.string.isRequired,
  
  timeValue: PropTypes.oneOf([TimeValue.present, TimeValue.future]),
  setTimeValue: PropTypes.func,
}
